import {onDomReady} from "./observer.js";

class SingleImageUploader {
    constructor() {
        this.options = {
            formMarkup: '[data-image-upload]',
            maxFileSize: 5 * 1024 * 1024, // 5MB
            allowedTypes: ['image/jpeg', 'image/png', 'image/bmp'],
        };

        this.elements = {
            formElements: document.querySelectorAll(this.options.formMarkup),
        };

        this.init();
    }

    init() {
        if (this.elements.formElements.length > 0) {
            this.elements.formElements.forEach((form, index) => {
                this.setupForm(form, index);
            });
        }
    }

    setupForm = (form, index) => {
        // Ensure form has an ID
        if (!form.id) {
            form.id = `uploadform-${index}`;
        }

        // Find file input
        const fileInput = form.querySelector('input[type="file"][accept=".jpg,.jpeg,.png,.bmp"]');
        if (!fileInput) {
            return;
        }
        // Ensure file input has an ID
        if (!fileInput.id) {
            fileInput.id = `pic-${form.id}`;
        }
        fileInput.setAttribute('aria-label', 'Upload an image');
        fileInput.setAttribute('aria-describedby', `${form.id}-instructions`);


        let dropZone = form.querySelector('label.drop-zone');
        /*
        if (!dropZone) {
            dropZone = document.createElement('label');
            dropZone.classList.add('drop-zone');
            dropZone.setAttribute('for', fileInput.id);
            dropZone.innerHTML = '<p>Add a photo or drag and drop here</p>';
            // If input is not wrapped, insert label before input
            if (!fileInput.parentElement.classList.contains('drop-zone')) {
                form.insertBefore(dropZone, fileInput);
            } else {
                // Replace existing parent with new label and re-append input
                fileInput.parentElement.replaceWith(dropZone);
                dropZone.appendChild(fileInput);
            }
        } else if (!dropZone.hasAttribute('for') && !dropZone.querySelector('input[type="file"]')) {
            dropZone.setAttribute('for', fileInput.id);
        }
         */

        // Add accessibility instructions
        if (!form.querySelector(`#${form.id}-instructions`)) {
            const instructions = document.createElement('div');
            instructions.id = `${form.id}-instructions`;
            instructions.textContent = 'Upload JPG, PNG, or BMP images, max 5MB.';
            instructions.style.display = 'none';
            form.appendChild(instructions);
        }

        // Bind events
        this.bindEvents(form, fileInput, dropZone);
    }

    bindEvents = (form, fileInput, dropZone) => {
        // Drag-and-drop events on label
        dropZone.addEventListener('dragover', (e) => {
            e.preventDefault();
            dropZone.classList.add('_dragover');
        });
        dropZone.addEventListener('dragleave', () => {
            dropZone.classList.remove('_dragover');
        });
        dropZone.addEventListener('drop', (e) => {
            e.preventDefault();
            dropZone.classList.remove('_dragover');
            const file = e.dataTransfer.files[0];
            if (file) {
                fileInput.files = this.createFileList(file);
                this.handleFile(file, form);
            }
        });

        // File input change
        fileInput.addEventListener('change', () => {
            const file = fileInput.files[0];
            if (file) {
                this.handleFile(file, form);
            }
        });
    }

    createFileList = (file) => {
        const dataTransfer = new DataTransfer();
        dataTransfer.items.add(file);
        return dataTransfer.files;
    }

    handleFile = (file, form) => {
        // Validate file
        if (!file || !this.options.allowedTypes.includes(file.type) || file.size > this.options.maxFileSize) {
            return;
        }
        // Submit form natively
        form.submit();
    }
}

onDomReady(() => {
    new SingleImageUploader();
}, false);